// export const authReducer = (state, action) => {
//     switch (action.type) {
//       case "LOGIN":
//         localStorage.setItem("token", action.token);
//         return action.token;
//       case "LOGOUT":
//         localStorage.removeItem("token");
//         return null;
//       default:
//         return state;
//     }
//   };


import Cookies from "js-cookie";
import {HOME_URL} from '../constants/constants'
export const authReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            // localStorage.setItem("token", action.token);
            Cookies.set("userToken", action.token, {domain: HOME_URL, secure: true});
            return action.token;
        case "LOGOUT":
            // localStorage.removeItem("token");
            Cookies.remove("userToken", {path: "/", domain: HOME_URL});

            return null;
        default:
            return state;
    }
};
